import React from 'react';
import ProTypes from 'prop-types';
import classnames from 'classnames';

import { replaceCitations } from '@Utils/String';
import capitalize from 'lodash/capitalize';

import './AlertContextTitle.theme.scss';

export default function AlertContextTitle(props) {
  const { context, className } = props;
  const displayContext = capitalize(replaceCitations(context));

  return (
    <h3 className={classnames('alert-context-title', 'u-els-font-size-h4', className)}>
      <span className="alert-context-title--text">{displayContext}</span>
    </h3>
  );
}

AlertContextTitle.propTypes = {
  context: ProTypes.string.isRequired,
  className: ProTypes.string,
};
